import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Styles } from '../../../css/table';
import { TablePagination } from '../../common/table/tablePagination';
import { skillConfigColumn } from '../../common/table/TableColumns/skillConfig';

const SkillTable = ({ pageCount, fetchData }) => {
  const { skillConfigs } = useSelector(state => state.gameConfig);

  return (
    <div className="w-full h-full">
      <Styles>
        <TablePagination
          columns={skillConfigColumn}
          data={skillConfigs?.data || []}
          total_item={skillConfigs?.total_items}
          fetchData={fetchData}
          pageCount={pageCount}
          className="rounded"
        />
      </Styles>
    </div>
  );
};
SkillTable.propTypes = {
  fetchData: PropTypes.func,
  pageCount: PropTypes.number,
};
export default SkillTable;
